// German-primary UI copy. A flat map keeps a simple widget simple — no next-intl.
// `t('remaining', { remaining, limit })` interpolates {placeholders}.
const DE = {
  trigger: 'Auf meinem Auto ansehen',
  trigger_hint: 'Sieh dein Auto in deiner Wunschfolie.',
  info_title: 'Auf meinem Auto ansehen',
  info_login: 'Dafür musst du in deinem Spezzial-Konto angemeldet sein.',
  info_quota: 'Pro Konto sind {limit} Vorschauen pro {period} möglich.',
  period_monthly: 'Monat',
  period_weekly: 'Woche',
  disclaimer_privacy_pre:
    'Dein Foto wird zur Generierung der Vorschau an unseren KI-Partner übermittelt und bei uns nicht gespeichert. Weitere Details findest du in unseren ',
  disclaimer_link: 'Datenschutzhinweisen',
  disclaimer_privacy_post: '.',
  disclaimer_legal:
    'Bei dem generierten Bild handelt es sich um eine unverbindliche, KI-gestützte Visualisierung. Farbabweichungen und darstellungsbedingte Ungenauigkeiten zur realen Folie sind möglich und stellen keinen Sachmangel dar.',
  info_before: 'Vorher',
  info_after: 'KI-Vorschau',
  info_before_alt: 'Auto vor der Folierung',
  info_after_alt: 'Auto in der Spezzial-Wunschfolie',
  info_compare: 'Vorher/Nachher vergleichen',
  info_continue: 'Anmelden',
  register_prompt: 'Noch kein Konto?',
  register_cta: 'Konto erstellen',
  auth_tab_login: 'Anmelden',
  auth_tab_register: 'Registrieren',
  login_title: 'Einloggen',
  login_username: 'Benutzername oder E-Mail',
  login_password: 'Passwort',
  login_submit: 'Einloggen',
  login_busy: 'Wird angemeldet …',
  login_error: 'Anmeldung fehlgeschlagen. Bitte überprüfe deine Zugangsdaten.',
  register_title: 'Konto erstellen',
  register_email: 'E-Mail-Adresse',
  register_password: 'Passwort',
  register_password_hint: 'Mindestens 8 Zeichen.',
  register_submit: 'Konto erstellen',
  register_busy: 'Wird erstellt …',
  register_error: 'Registrierung fehlgeschlagen. Bitte versuche es erneut.',
  // SPEZ-14 — marketing opt-in (split pre / link / post so the Datenschutzerklärung is a real anchor).
  marketing_optin_pre:
    'Ja, ich möchte regelmäßig per E-Mail über exklusive Angebote und Neuigkeiten ' +
    'informiert werden. Ich kann diese Einwilligung jederzeit mit Wirkung für die ' +
    'Zukunft widerrufen, z. B. über den Abmeldelink am Ende jedes Newsletters. ' +
    'Weitere Informationen zur Datenverarbeitung finde ich in der ',
  marketing_optin_link: 'Datenschutzerklärung',
  marketing_optin_post: '.',
  choose_file: 'Datei auswählen',
  change_file: 'Anderes Foto wählen',
  no_file: 'Keine Datei ausgewählt',
  modal_title: 'Wunschfarbe live ansehen',
  close: 'Schließen',
  step_product: 'Folie auswählen',
  step_product_hint: 'Wähle das Produktbild, das deine Wunschfolie zeigt.',
  step_vehicle: 'Foto deines Autos',
  step_vehicle_hint: 'Lade ein Foto deines Fahrzeugs hoch (eine Seitenansicht funktioniert am besten).',
  upload_alt: 'Hochgeladenes Fahrzeugfoto',
  apply: 'Vorschau erstellen',
  applying: 'Wird generiert …',
  result_label: 'Vorschau',
  result_alt: 'KI-Vorschau deines Autos',
  download: 'Herunterladen',
  new_preview: 'Neue Vorschau',
  remaining: 'Noch {remaining} von {limit} Vorschauen',
  no_images: 'Für dieses Produkt sind keine Bilder verfügbar.',
  err_type: 'Bitte ein Bild hochladen.',
  err_size: 'Das Bild darf höchstens {mb} MB groß sein.',
  err_no_product: 'Bitte zuerst eine Folie (Produktbild) auswählen.',
  err_no_vehicle: 'Bitte ein Foto deines Autos hochladen.',
  err_quota: 'Du hast dein Limit für diesen Zeitraum erreicht.',
  err_generic:
    'Es konnte keine Vorschau erstellt werden. Bitte versuche es erneut.',
} as const;

export type StringKey = keyof typeof DE;

export function t(key: StringKey, vars?: Record<string, string | number>): string {
  let out: string = DE[key];
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      out = out.replace(`{${k}}`, String(v));
    }
  }
  return out;
}
